import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { Auth0Error } from 'modules/auth/types/auth0'
import { postRevokeRefreshToken } from '../api/postRevokeRefreshToken'

interface Props {
  mutationOptions?: UseMutationOptions<void, AxiosError<Auth0Error>>
}

export const usePostRevokeRefreshTokenMutation = ({
  mutationOptions,
}: Props = {}) => {
  return useMutation<void, AxiosError<Auth0Error>>({
    mutationFn: postRevokeRefreshToken,
    ...mutationOptions,
  })
}
